import { Exception } from 'app/api/exception/Exception';
import { OtpConfirmation } from 'app/model/OtpConfirmation';

/**
 * Исключение используется в случае ошибок подтверждения OTP.
 * HTTP статус код для ошибок валидации: 422 Unprocessable entity.
 */
export class OtpValidationException extends Exception {
    static readonly NAME = 'OtpValidationException';

    constructor(
        id: string,
        type: string,
        message: string,
        otpConfirmation: OtpConfirmation,
    ) {
        super(id, type, message);
        this.name = OtpValidationException.NAME;
        this.confirmation = otpConfirmation;
    }

    /**
     * Обновленная информация с настройками ввода otp
     */
    confirmation: OtpConfirmation;
}
